<!--
 * @Author: HJK
 * @Date: 2023年12月15日11:16:57
 * @LastEditors: Please set LastEditors
 * @Description: 针对[河北建筑工程学院]展示课程的courseList组件
-->
<template>
  <div class="courseList_hbjz">
    <el-row
      class="list_class"
      :gutter="30"
      v-loading="loading_data"
      ref="list_class"
    >
      <el-col
        :span="8"
        :class="$strExistHostnameOnce(['localhost','hbsi'])?'list_info_':''"
        v-for="(item, index) in teachingPlanCourseAllList"
        :key="index"
      >
        <h4 style="margin: 15px 0 10px 0; font-size: 16px" class="courseName">
          {{ item.courseName }}
          <el-tag
              class="courseTag"
              >{{ item.semestersText }}</el-tag
            >
          <el-tag class="courseTag" v-if="item.courseNatureConcat">{{
            item.courseNatureConcat
          }}</el-tag>
          <el-tooltip
            class="item"
            effect="dark"
            :content="item | filterCourseTip"
            placement="top-start"
          >
            <i class="el-icon-warning-outline" />
          </el-tooltip>
        </h4>
        <el-row>
          <div style="height: 140px">
            <el-image
              class="logo"
              :src="
                $isEmpty(item.courseThumbnail)
                  ? png
                  : $isHttp(item.courseThumbnail)
              "
            />
            <p
              v-for="item in timeList"
              :key="item.title"
              class="sj p_ limit_line_one"
              style="padding-top: 10px; margin-top: 0"
            >
              {{ item.title }}
              <template v-if="item[item.authField] == '显示'">
                <el-tooltip
                  class="item"
                  effect="light"
                  placement="top"
                  :content="item.title + $timeFormatTo(item[item.valueField])"
                >
                  <span>{{ $timeFormatTo(item[item.valueField]) }}</span>
                  <!-- <span> 2024-01-20 09:00 至 2024-01-24 21:00</span> -->
                </el-tooltip>
              </template>
            </p>
            <p
              class="sj p_ limit_line_one"
              style="display: flex; align-items: center"
            >
              <span style="flex: 0 0 auto">学习进度：</span>
              <el-progress
                :percentage="percentCompleteMap[item.tePlanCourseId]"
                color="#70b603"
                :stroke-width="12"
                style="width: 200px; float: left"
              ></el-progress>
            </p>
          </div>
          <!-- <div style="color: red; font-size: 14px; margin-top: 10px">
            总成绩 = 学习成绩*{{ item.weight1Str || 0 }} + 作业成绩*{{
              item.weight3Str || 0
            }}
            + 表现成绩*{{ item.weight2Str || 0 }} + 考试成绩*{{
              item.weight4Str || 0
            }}
          </div> -->
          <div style="text-align: right; margin-top: 10px;min-height: 30px;">
            <el-button
              v-for="btn in btnList"
              :key="btn.title"
              class="butInfo"
              size="mini"
              v-show="btn.showCondition(item)"
              @click="onBtnClickTactics(btn.clickCallFn, item)"
              >{{ btn.title }}</el-button
            >
          </div>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { openWithRoleTag, getStudentInfoKeyForRoleTag } from "../common/ulit";
import png from "@/images/course.png";
export default {
  name: "CourseList",
  components: {},
  props: {},
  data() {
    return {
      png: png,
      loading_data: false,
      teachingPlanCourseMap: {}, //课程信息map 所有学期
      mapIndex: [],
      teachingPlanCourseList: [], //课程信息
      teachingPlanCourseAllList: [], //所有课程信息，平面数组
      videoList: [], //已学进度
      getNowTime: "",
      percentCompleteMap: {}, //完成比例
      activeNames: [""],
      btnList: [
        {
          title: "学习",
          showCondition: (item) => item.infoShow1Str == "显示",
          clickCallFn: "study",
        },
        {
          title: "作业",
          showCondition: (item) => item.infoShow3Str == "显示",
          clickCallFn: "schoolAssignment",
        },
        {
          title: "考试",
          showCondition: (item) => item.infoShow4Str == "显示",
          clickCallFn: "examList",
        },
        {
          title: "提问",
          showCondition: (item) => item.infoShow5Str == "显示",
          clickCallFn: "putQuestions",
        },
        {
          title: "成绩",
          showCondition: (item) => item.infoShow4Str == "显示",
          clickCallFn: "scoreQuery",
        },
      ],
      timeList: [
        {
          title: "学习时间",
          valueField: "infoTime1Str",
          authField: "infoShow1Str",
        },
        {
          title: "学习时间",
          valueField: "infoTime3Str",
          authField: "infoShow3Str",
        },
        {
          title: "学习时间",
          valueField: "infoTime4Str",
          authField: "infoShow4Str",
        },
      ],
    };
  },
  filters: {
    filterCourseTip(item) {
      const { weight1Str, weight2Str, weight3Str, weight4Str } = item;
      return `总成绩 = 学习成绩( ${weight1Str || 0}   + 作业成绩 * ${
        weight3Str || 0
      }+ 表现成绩 * ${weight2Str || 0}  + 考试成绩 * ${weight4Str || 0}`;
    },
  },
  created() {
    this.getLeaningCenterList();
    this.getNowDate();
  },
  mounted() {
    this.setImgTranslateOnPoint();
  },
  methods: {
    setImgTranslateOnPoint() {
      const dom = this.$refs.list_class.$el;
      console.log("找到dom", dom);

      const imgs = dom.querySelectorAll("img");
      console.log("找到所有的imgs", imgs);
    },
    onBtnClickTactics(fnName, params) {
      this[fnName](params);
    },
    getLeaningCenterList() {
      //获取课程List
      this.loading_data = true;
      let param = {
        page: 1,
        limit: 9999,
        semesterType: 2,
      };
      this.$store.dispatch("user/getLeaningCenterList", param).then((ret) => {
        const { code, msg, data } = ret;
        if ("" + code === "0") {
          this.teachingPlanCourseMap = data;
          let list = [];
          let value = "";
          for (let item in data) {
            value = data[item];
            list.push({
              index: item.replace("第", "").replace("学期", ""),
              key: item,
            });
            this.teachingPlanCourseList.push(data[item]);
          }
          this.mapIndex = list.sort((a, b) => a.index - b.index); //根据学期排序
          sessionStorage.setItem(
            getStudentInfoKeyForRoleTag() + "_onlineLearningAllRows",
            JSON.stringify(ret.data)
          );
          //根据课程tePlanCourseIds查询课程学习进度
          let tePlanCourseIds = "";
          const tePlanCourseIdSet = new Set([]);
          this.teachingPlanCourseList.forEach((arr) => {
            arr.forEach((item) => tePlanCourseIdSet.add(item.tePlanCourseId));
          });
          this.teachingPlanCourseAllList = Object.values(
            this.teachingPlanCourseMap
          ).flat();
          //   this.teachingPlanCourseAllList =
          //     this.teachingPlanCourseAllList.concat(
          //       this.teachingPlanCourseAllList
          //     );
          //   console.log("平面数组构建完成", this.teachingPlanCourseAllList);
          this.loading_data = false;
          if (tePlanCourseIdSet.size > 0) {
            const tePlanCourseIds = [...tePlanCourseIdSet].join(",");
            this.getStudentVideoInfo(tePlanCourseIds);
          }
        } else {
          this.$message.warning(msg);
        }
      });
    },
    getStudentVideoInfo(tePlanCourseIds) {
      //查询课程的已学进度
      this.$store
        .dispatch("user/getStudentVideoInfo", {
          tePlanCourseIds: tePlanCourseIds,
        })
        .then((ret) => {
          if (ret.code === 0 || ret.code === "0") {
            ret.data.forEach((item) => {
              this.percentCompleteMap[item.tePlanCourseId] = Number(
                item.percentComplete.replace("%", "")
              );
            });
            // this.percentCompleteMap["1731511241497419776"] = 90;
            // console.log("百分比赋值完成", this.percentCompleteMap);
            this.$forceUpdate();
          } else {
            this.$message({ message: ret.msg, type: "warning" });
          }
        })
        .catch(() => {});
    },
    study(item) {
      //学习
      let infoTime1Str = item.infoTime1Str; //学习时间
      let startDate = infoTime1Str.split(" 至 ")[0]; //开始时间
      let endDate = infoTime1Str.split(" 至 ")[1]; //结束时间
      const date = this.getNowTime; //当前时间
      // const date = "2022-12-10 00:20:20"; //当前时间
      if (this.$compareTime(date, startDate)) {
        this.$message({
          message: "学习时间还未开始",
          type: "error",
        });
        return;
      }
      if (this.$compareTime(endDate, date)) {
        this.$message({
          message: "学习时间已结束",
          type: "error",
        });
        return;
      }
      openWithRoleTag(
        window.location.origin +
          "/StartLearning?tePlanCourseId=" +
          item.tePlanCourseId +
          "&courseName=" +
          this.$Base64.encode(item.courseName)
      );
      // if(!this.$isEmpty(item.courseUrl)){
      //   window.open(item.courseUrl);
      // }else{
      //   window.open(window.location.origin + '/StartLearning?tePlanCourseId='+item.tePlanCourseId);
      // }
    },
    schoolAssignment(item) {
      //作业
      let infoTime3Str = item.infoTime3Str; //作业时间
      let startDate = infoTime3Str.split(" 至 ")[0]; //开始时间
      let endDate = infoTime3Str.split(" 至 ")[1]; //结束时间
      const date = this.getNowTime; //当前时间
      // const date = "2022-12-10 00:20:20"; //当前时间
      if (this.$compareTime(date, startDate)) {
        this.$message({
          message: "作业时间还未开始",
          type: "error",
        });
        return;
      }
      if (this.$compareTime(endDate, date)) {
        this.$message({
          message: "作业时间已结束",
          type: "error",
        });
        return;
      }
      openWithRoleTag(
        window.location.origin +
          "/SchoolAssignment?tePlanCourseId=" +
          item.tePlanCourseId +
          "&courseName=" +
          this.$Base64.encode(item.courseName)
      );
    },
    scoreQuery() {
      this.$router.push({ name: "ScoreQuery" });
    },
    examList(item) {
      //考试
      let infoTime4Str = item.infoTime4Str; //考试时间
      let startDate = infoTime4Str.split(" 至 ")[0]; //开始时间
      let endDate = infoTime4Str.split(" 至 ")[1]; //结束时间
      const date = this.getNowTime; //当前时间
      // const date = "2022-12-10 00:20:20"; //当前时间
      if (this.$compareTime(date, startDate)) {
        this.$message({
          message: "考试时间还未开始",
          type: "error",
        });
        return;
      }
      if (this.$compareTime(endDate, date)) {
        this.$message({
          message: "考试时间已结束",
          type: "error",
        });
        return;
      }
      openWithRoleTag(
        window.location.origin +
          "/ExamList?tePlanCourseId=" +
          item.tePlanCourseId +
          "&courseName=" +
          this.$Base64.encode(item.courseName)
      );
    },
    putQuestions(item) {
      //提问
      openWithRoleTag(
        window.location.origin +
          "/PutQuestions?tePlanCourseId=" +
          item.tePlanCourseId +
          "&courseName=" +
          this.$Base64.encode(item.courseName)
      );
    },
    getNowDate() {
      const this_ = this;
      this.$store
        .dispatch("getNowTime")
        .then((res) => {
          if (res.code == 0) {
            this.getNowTime = res.data;
            // 对比当前时间和服务器时间（对比时间戳），如果时间相差超过【55秒钟】提示用户修改本地时间，否者可能会影响学习及考试结果
            let timeStamp_ = new Date(this.getNowTime).getTime() - new Date().getTime(); //两个时间戳的差值
            if(Math.abs(timeStamp_)  >= 1000 * 55){ //Math.abs 取绝对值
                // localStorage.setItem(this.$getStorageKeyForRoleTag("timeStamp_"),timeStamp_);
                //时间差大于55秒弹出提示信息
                this.$notify({
                    title: '系统提示',
                    type: 'warning',
                    position: 'bottom-right',
                     dangerouslyUseHTMLString: true,
                    message: '<h3 style="text-indent: 2em;color:red;">您的电脑时间与实际时间存在一定偏差，<br/>会影响学习及考试结果,<span>请及时调整！</span></h3>',
                    duration: 0
                });
            }
          } else {
            this.getNowTime = this.$getNewDate();
          }
        })
        .catch(function (error) {
          this_.getNowTime = this_.$getNewDate();
        });
    },
  },
};
</script>
<style lang="less">
@import "../styles/base.less";
.courseList_hbjz {
  .t_r {
    text-align: right;
  }

  .sj {
    color: #828282;
    font-size: 14px;
  }

  .p_ {
    margin-left: 5px;
    margin-bottom: 0;
    line-height: 20px;
    font-size: 10px;
  }

  .titleClass {
    margin-left: 10px;
    font-weight: 500;
  }
  .courseName {
    border-left: 4px solid @butBg;
    padding-left: 0.5em;
  }
  .courseTag {
    height: auto;
    background-color: @butBg;
    color: white;
    font-weight: 100;
    // float: right;
    border-radius: 20px;
    padding: 10px;
    font-size: 12px;
    line-height: 0;
    transition: 0.3s ease;
    &:hover {
      outline: 2px solid lighten(@butBg, 10%);
    }
  }

  .el-progress__text {
    font-size: 12px !important;
  }
  .butInfo {
    color: white;
    padding: 8px 20px;
  }
  .butInfo:nth-child(2n) {
    background-color: #1eb0bb;
  }
  .butInfo:nth-child(2n + 1) {
    background-color: #73a1f7;
  }
  .list_class {
    margin-bottom: 20px;
    .el-col {
      // background: linear-gradient(to bottom, #fff, lighten(@butBg, 10%) 100%);
      padding: 0.4em 15px;
      box-sizing: border-box;
      border-radius: 10px;
      // box-shadow: 0 0 5px #fff inset;
    }
    .list_info_{
        background: linear-gradient(to bottom, #fff, lighten(@butBg, 10%) 100%);
        box-shadow: 0 0 5px #fff inset;
    }
    .el-row {
      .el-image {
        height: 140px;
        width: 240px;
        float: left;
        margin-right: 10px;
        border-radius: 10px;
        // img {
        //   width: 110%;
        //   height: 110%;
        // }
      }
    }
  }
  .el-button:focus,
  .el-button:hover {
    color: white !important;
  }
  .list_class:nth-child(2n) {
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/courseList_hbjz.vue